define('models/DiagnosisCode',['core/can'], function() {
	
	return can.Map.extend({
		// ICD Format Validation
		// http://stackoverflow.com/questions/5590862/icd9-regex-pattern		
		isValidICD9: function (code) {
			return (/^([vV]\d{2}((\.)?\d{1,2})?|\d{3}((\.)?\d{1,2})?|E\d{3}((\.)?\d)?)$/).test(code);
		},
		
		isValidICD10: function (code) {
			return (/^[A-TV-Z][0-9][A-Z0-9]((\.)?[A-Z0-9]{1,4})?$/).test(code);
		}
	},{
		
		define: {
			Code: {
				type: 'string'
			},
			PresentOnAdmissionIndicator: {
				type: 'string', // TODO bool
				value: '' // Fix for DDE-158: Null is being sent as string and gets stored in the DB as such.
			}
		}
	});

});
